import type { StudySet } from "@studygenie/db";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePathname, useRouter } from "next/navigation";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useDeleteStudyset = ({ id }: { id: string }) => {
  const router = useRouter();
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return useMutation(
    trpc.studysets.delete.mutationOptions({
      onSuccess: async () => {
        if (pathname.includes(id)) {
          router.push("/my-studysets");
        }

        queryClient.setQueriesData<StudySet[]>(
          {
            queryKey: trpc.studysets.get.queryKey(),
          },
          (existingData) =>
            existingData?.filter((s) => s.id !== id) ?? existingData,
        );

        queryClient.invalidateQueries({
          queryKey: trpc.folders.getStudySets.queryKey(),
        });

        toast.success("Studyset deleted successfully");
      },
      onError: (error) => {
        console.error("Failed to delete studyset", error);
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.get.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getStudySets.queryKey(),
        });
        toast.error(error.message);
      },
    }),
  );
};
